export default "__VITE_ASSET__Cn7Dkpgi__"